// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-dashboard-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.delete-dashboard-container{
    padding: 10px 25px;
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    box-sizing: border-box;
}
.delete-dashboard-container h1{
    margin: 20px 0px;
    font-size: 20px;
    font-weight: 600;
}
.delete-dashboard-container p{
    margin: 20px 0px;
    color: rgb(114, 114, 114);
}
.delete-dashboard-container .buttons-container{
    text-align: right;
    padding-top: 16px;
    box-sizing: border-box;
}
.delete-dashboard-container .buttons-container button{
    border: none;
    margin-left: 5px;
    cursor: pointer;
    border-radius: 4px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 14px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: rgba(155, 30, 30, 0.952);
    background-color: transparent;
    transition: color 0.25s ease-in,background-color 0.25s ease-in;
}
.delete-dashboard-container .buttons-container button:hover{
    background-color: rgba(245, 245, 245, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/DeleteDashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4DAA4D;IAC5D,+BAA+B;IAC/B,6BAA6B;IAC7B,8DAA8D;AAClE;AACA;IACI,4CAA4C;AAChD","sourcesContent":[".delete-dashboard-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.delete-dashboard-container{\r\n    padding: 10px 25px;\r\n    background-color: white;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    border-radius: 5px;\r\n    box-sizing: border-box;\r\n}\r\n.delete-dashboard-container h1{\r\n    margin: 20px 0px;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n.delete-dashboard-container p{\r\n    margin: 20px 0px;\r\n    color: rgb(114, 114, 114);\r\n}\r\n.delete-dashboard-container .buttons-container{\r\n    text-align: right;\r\n    padding-top: 16px;\r\n    box-sizing: border-box;\r\n}\r\n.delete-dashboard-container .buttons-container button{\r\n    border: none;\r\n    margin-left: 5px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    padding: 10px 24px;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: transparent;\r\n    transition: color 0.25s ease-in,background-color 0.25s ease-in;\r\n}\r\n.delete-dashboard-container .buttons-container button:hover{\r\n    background-color: rgba(245, 245, 245, 0.952);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
